"use strict";
/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0.
 */

var _classCallCheck = require("/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscoverResponse = exports.GGGroup = exports.GGCore = exports.ConnectivityInfo = void 0;
/**
 * @packageDocumentation
 * @module greengrass
 */

var util_1 = require("util");
/**
 * Describes a Greengrass core endpoint that a device can connect to
 *
 * API Documentation: https://docs.aws.amazon.com/greengrass/latest/developerguide/gg-discover-api.html
 *
 * @category Greengrass
 */


var ConnectivityInfo = /*#__PURE__*/function () {
  function ConnectivityInfo(
  /** Connectivity entry identifier */
  id,
  /** Endpoint address */
  host_address,
  /** Endpoint port */
  port,
  /** Additional user-configurable metadata about the connectivity entry */
  metadata) {
    _classCallCheck(this, ConnectivityInfo);

    this.id = id;
    this.host_address = host_address;
    this.port = port;
    this.metadata = metadata;
  }
  /** @internal */


  _createClass(ConnectivityInfo, null, [{
    key: "from_json",
    value: function from_json(json) {
      return new ConnectivityInfo(json.Id, json.HostAddress, json.PortNumber, json.Metadata);
    }
  }]);

  return ConnectivityInfo;
}();

exports.ConnectivityInfo = ConnectivityInfo;
/**
 * Describes a Greengrass Core
 *
 * API Documentation: https://docs.aws.amazon.com/greengrass/latest/developerguide/gg-discover-api.html
 *
 * @category Greengrass
 */

var GGCore = /*#__PURE__*/function () {
  function GGCore(
  /** resource name of the IoT thing associated with a Greengrass core */
  thing_arn,
  /** list of distinct ways to connect to the associated Greengrass core */
  connectivity) {
    _classCallCheck(this, GGCore);

    this.thing_arn = thing_arn;
    this.connectivity = connectivity;
  }
  /** @internal */


  _createClass(GGCore, null, [{
    key: "from_json",
    value: function from_json(json) {
      var connectivity = [];

      if (json.Connectivity && (0, util_1.isArray)(json.Connectivity)) {
        json.Connectivity.forEach(function (payload) {
          connectivity.push(ConnectivityInfo.from_json(payload));
        });
      }

      return new GGCore(json.thingArn, connectivity);
    }
  }]);

  return GGCore;
}();

exports.GGCore = GGCore;
/**
 * Describes a Greengrass group
 *
 * API Documentation: https://docs.aws.amazon.com/greengrass/latest/developerguide/gg-discover-api.html
 *
 * @category Greengrass
 */

var GGGroup = /*#__PURE__*/function () {
  function GGGroup(
  /** identifier for the Greengrass group */
  gg_group_id) {
    var cores = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var certificate_authorities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, GGGroup);

    this.gg_group_id = gg_group_id;
    this.cores = cores;
    this.certificate_authorities = certificate_authorities;
  }
  /** @internal */


  _createClass(GGGroup, null, [{
    key: "from_json",
    value: function from_json(json) {
      var cores = [];

      if (json.Cores && (0, util_1.isArray)(json.Cores)) {
        json.Cores.forEach(function (payload) {
          cores.push(GGCore.from_json(payload));
        });
      }

      return new GGGroup(json.GGGroupId, cores, json.CAs);
    }
  }]);

  return GGGroup;
}();

exports.GGGroup = GGGroup;
/**
 * Response returned from a {@link DiscoveryClient.discover} call
 *
 * API Documentation: https://docs.aws.amazon.com/greengrass/latest/developerguide/gg-discover-api.html
 *
 * @category Greengrass
 */

var DiscoverResponse = /*#__PURE__*/function () {
  function DiscoverResponse() {
    var gg_groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, DiscoverResponse);

    this.gg_groups = gg_groups;
  }
  /** @internal */


  _createClass(DiscoverResponse, null, [{
    key: "from_json",
    value: function from_json(json) {
      var groups = [];

      if (json.GGGroups && (0, util_1.isArray)(json.GGGroups)) {
        json.GGGroups.forEach(function (payload) {
          groups.push(GGGroup.from_json(payload));
        });
      }

      return new DiscoverResponse(groups);
    }
  }]);

  return DiscoverResponse;
}();

exports.DiscoverResponse = DiscoverResponse;